import React, { useEffect, useState, useCallback } from 'react';
import { enUS } from 'date-fns/locale';
import Datepicker, { ReactDatePickerProps as AtoZDatepickerProps, registerLocale, getDefaultLocale } from 'react-datepicker';

import './styles.css';

/**
 * Looks up a date-fns locale from the browser locale if provided.  This falls back to `en-US`
 * @param String String object containing the browser locale
 * @returns date-fns locale.
 */
export const getDateFnsLocale = async (locale: string): Promise<Locale> => {
  try {
    try {
      // First try the full locale, xx-XX
      const localeResult = await import(
        /* webpackChunkName: "date-fns/locale-[request]", webpackExclude: /_lib/ */
        `date-fns/locale/${locale}/index.js`
      );

      return localeResult.default;
    } catch (error) {
      // Try the shortened locale next if that fails
      const localeResult = await import(
        /* webpackChunkName: "date-fns/locale-[request]", webpackExclude: /_lib/ */
        `date-fns/locale/${locale.substring(0, 2)}/index.js`
      );
      return localeResult.default;
    }

  } catch (error) {
    // If both the long and short locale module lookup fail, default to en-US
    return enUS;
  }
}


const AtoZDatepicker: React.FC<AtoZDatepickerProps> = (props) => {
    const { locale } = props
    const targetLocaleCode: string | undefined = typeof locale === 'string' ? locale : locale?.code;

    const [inUseLocaleCode, setInUseLocaleCode] = useState<string>(getDefaultLocale())

    const setupLocale = useCallback(
        async (targetLocaleCode) => {
            if (!targetLocaleCode || targetLocaleCode.length === 0) return;
            const dateFNSLocale = await getDateFnsLocale(targetLocaleCode!);
            registerLocale(targetLocaleCode, dateFNSLocale);
            setInUseLocaleCode(targetLocaleCode)
        },
        []
    );
    useEffect(() => {
        setupLocale(targetLocaleCode);
    }, [targetLocaleCode != inUseLocaleCode]);

  return <Datepicker showPopperArrow={false} {...props}/>;
}

export default AtoZDatepicker;
export type { AtoZDatepickerProps }
